import { render, staticRenderFns } from "./LabelDate.vue?vue&type=template&id=12664c07&scoped=true"
import script from "./LabelDate.vue?vue&type=script&lang=js"
export * from "./LabelDate.vue?vue&type=script&lang=js"
import style0 from "./LabelDate.vue?vue&type=style&index=0&id=12664c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12664c07",
  null
  
)

export default component.exports